import { cn } from "@/lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndustry } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import React from "react";
import { Avatar, AvatarFallback } from "../ui/avatar";
import {
  AVATAR_SIZE_CLASS_MAP,
  AvatarSize,
  INITIALS_SIZE_CLASS_MAP,
} from "./const";

type GroupAvatarProps = {
  size: AvatarSize;
  className?: string;
};

export const GroupAvatar: React.FC<GroupAvatarProps> = ({
  size,
  className,
}) => {
  return (
    <Avatar className={cn(AVATAR_SIZE_CLASS_MAP[size], className)}>
      <AvatarFallback
        className={cn(
          INITIALS_SIZE_CLASS_MAP[size],
          "bg-foreground-2",
          className,
        )}
      >
        <FontAwesomeIcon icon={faIndustry} />
      </AvatarFallback>
    </Avatar>
  );
};
